import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { TEST_IDS } from 'modules/predictiveGoals/constants';
import { useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { colors, fontSizes, fontWeights } from 'ui/theme';
import { DonutTooltipContent, TooltipFeatureText, TooltipPercentageText } from './Styled';

type DonutChartProps = {
  chartData: { name: string; y: number }[];
  chartTitle?: string;
};

export const DonutChart = ({ chartData, chartTitle }: DonutChartProps) => {
  const [donutOptions, setDonutOptions] = useState<Highcharts.Options>({
    chart: {
      animation: false,
      plotBorderWidth: 0,
      plotShadow: false,
      height: '95%',
    },
    exporting: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      followPointer: false,
      backgroundColor: 'white',
      borderColor: 'white',
      borderRadius: 4,
      borderWidth: 0,
      padding: 0,
      useHTML: true,
      shadow: {
        opacity: 0.04,
        width: 1,
      },
      formatter: function tooltipFormatter() {
        const tooltipSectionContent = (
          <DonutTooltipContent>
            <TooltipFeatureText>{this.point.name}</TooltipFeatureText>
            <TooltipPercentageText> {(this.y * 100).toFixed(0)}%</TooltipPercentageText>
          </DonutTooltipContent>
        );
        return ReactDOMServer.renderToStaticMarkup(tooltipSectionContent);
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false,
        },
        innerSize: '65%',
        borderWidth: 2,
        startAngle: 365 - chartData[0].y * 133,
        size: '93.18%',
      },
      series: {
        states: {
          inactive: {
            opacity: 1,
          },
        },
      },
    },
    title: {
      style: {
        fontFamily: 'Sofia Pro',
        textAlign: 'center',
        align: 'center',
        verticalAlign: 'middle',
      },
      useHTML: true,
      text: `
      <h3 y="140" style="
        font-size: ${fontSizes.s24};
        font-weight: ${fontWeights.bold};
        line-height: 28px;
        letter-spacing: -0.25px;
        margin: 0;
      ">${chartTitle}</h3>
      <p style="
        line-height: 20px;
        font-weight: ${fontWeights.regular};
        font-style: 'normal';
        font-size: ${fontSizes.s14};
        letter-spacing: 0.1px;
        color: ${colors.textSecondary};
        margin: 0;
      ">total</p>
      `,
      align: 'center',
      verticalAlign: 'middle',
      y: 20,
    },
    series: [
      {
        type: 'pie',
        // data filled in parse function
        data: chartData,
        states: {
          hover: {
            halo: null,
            brightness: -0.2,
          },
        },
      },
    ],
  });

  // old version of highcharts will only allow chart resizing on window resize event, this is the current solution
  setTimeout(() => {
    window.dispatchEvent(new Event('resize'));
    // update with passed series data
    setDonutOptions(donutOptions);
  }, 75);

  const donutChart = <HighchartsReact highcharts={Highcharts} options={donutOptions} />;

  return <div data-test={`${TEST_IDS.DonutChart}`}>{donutChart}</div>;
};
